import { FC, MutableRefObject } from 'react';

import { Bonus } from '../../../../../../types/bonus';
import { BonusContent } from '../../bonus/bonus-content';

interface BonusModalContentProps {
	bonus: Bonus;
	commentsDefaultOpen?: boolean;
	commentBoxRef: MutableRefObject<HTMLDivElement | null>;
	disableCardClick?: boolean;
}
export const BonusModalContent: FC<BonusModalContentProps> = ({ bonus, commentsDefaultOpen = true, commentBoxRef, disableCardClick = false }) => {
	return (
		<BonusContent
			bonus={bonus}
			shouldCommentBeOpenedInModal={commentsDefaultOpen}
			commentBoxRef={commentBoxRef}
			disableCardClick={disableCardClick}
			isInModal
		/>
	);
};
